<div class="page-layout blank p-12" fusePerfectScrollbar>
    <div class="w-100-p h-100-p">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mt-8">
            <div>
                <h4>Check-in</h4>
            </div>
        </div>

        <!-- Nenhum agendamento -->
        <div *ngIf="!dataSource.length" class="empty-state">
            <p>Sem agendamento para check-in.</p>
            <a routerLink="/agenda">Clique aqui para agendar</a>
        </div>

        <!-- Lista de agendamentos -->
        <ng-container *ngIf="dataSource.length">
            <div class="cards-container">
                <div class="card-item" *ngFor="let element of dataSource">
                    <div class="card-header">
                        <div class="card-date">
                            {{ element.date | date: "dd/MM/yy" }} - {{ element.hour.substring(0, 5) }}
                        </div>

                        <button mat-icon-button
                            [title]="element.patientStatus === 'P' ? 'Check-in Realizado' : 'Realizar check-in'"
                            color="primary" (click)="checkIn(element)" [disabled]="element.patientStatus === 'P'">
                            <mat-icon>
                                {{
                                element.date === currentDate && element.patientStatus !== 'P'
                                ? 'check'
                                : 'done'
                                }}
                            </mat-icon>
                        </button>
                    </div>

                    <div class="card-body">
                        <div class="info-line">
                            <span class="label">Unidade:</span>
                            <span class="value">{{ element.companyAlias }}</span>
                        </div>
                        <div class="info-line">
                            <span class="label">Profissional:</span>
                            <span class="value">{{ element.performerName }}</span>
                        </div>
                        <div class="info-line">
                            <span class="label">Procedimento:</span>
                            <span class="value">{{ element.procedureName }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- paginator abaixo -->
            <div class="paginator-wrapper">
                <mat-paginator #paginator showFirstLastButtons [length]="totalElements" [pageIndex]="pagina"
                    [pageSizeOptions]="[10, 25]" (page)="getSCheduleList($event, 'page')">
                </mat-paginator>
            </div>
        </ng-container>
    </div>
</div>